import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

interface IAddNewCoachPackageProps {
  onClick: () => void;
  height?: string;
}

export default function AddNewCoachPackage({
  onClick,
  height,
}: Readonly<IAddNewCoachPackageProps>) {
  const { t } = useTranslation();
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <Box
      sx={{
        minWidth: {
          xs: '70%',
          sm: '70%',
          md: 'calc(50% - 16px)',
          lg: '333px',
        },
        width: {
          xs: '100%',
          sm: 'calc(50% - 16px)',
          md: 'calc(33.33% - 16px)',
          lg: 'calc(25% - 16px)',
        },
        height: height ?? '500px',
        borderRadius: '10px',
        border: '1px dashed #7CAEBE',
        padding: '0 32px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          onClick={onClick}
          disabled={
            !checkPermissions(UserPermissionType.BOOKINGS_MODULE_MANAGE_COACH_CONFIGURATIONS)
          }
        >
          <img src="/assets/icons/add-new-service-package.svg" alt="add" />
        </Button>
      </Box>
      <Typography variant="bodyBold" color="#7CAEBE">
        {t('bookings.coachServicePackages.addNewPackage')}
      </Typography>
    </Box>
  );
}
